module.exports = __webpack_public_path__ + "img/wmcsxc.6f93b27e.jpg";